import type { ReactNode } from 'react';

export const symbol_r_mobiledata: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M140-675v85q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63Q80-577.25 80-590v-260q0-12.75 8.63-21.38Q97.25-880 110-880h191q24 0 42 18t18 42v85q0 19-12 36t-45 21l30 68q8 17.65-2 33.82Q322-560 302-560q-11 0-19.61-6T269-582l-41-93h-88Zm0-60h161v-85H140v85Z"
		/>
	</svg>
);
